import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {PriceField} from "@/components/price_field/PriceField";

import {
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT,
    HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {HomeMatchPreferencesWizardFinancingOption} from "../../home_match_preferences_wizard/HomeMatchPreferencesWizardFinancingOption";

const {BUDGET_QUESTION, FINANCING} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;
const {BUDGET_PLACEHOLDER} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

export const HomeMatchPreferencesSurveyBudgetFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const financing = watch("financing");
    const priceUpper = watch("price.upper");

    return (
        <>
            <div className={budgetFieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {BUDGET_QUESTION}
                </Text>
                <div data-testid={KM_PREFERENCES_FORM_TEST_IDS.BUDGET}>
                    <PriceField
                        classNames={{
                            amount: budgetAmountStyle,
                            field: budgetControlStyle,
                            input: budgetAmountValueStyle,
                            inputWrap: budgetAmountWrapStyle,
                            inputWrapper: budgetAmountBoxStyle,
                            root: budgetPriceFieldStyle
                        }}
                        name="price.upper"
                        placeholder={BUDGET_PLACEHOLDER}
                        showPlaceholderAtMin
                        value={priceUpper}
                    />
                </div>
            </div>

            <div className={inlineOptionsStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {FINANCING}
                </Text>
                <div className={pillRowStyle}>
                    {HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS.map((option) => (
                        <HomeMatchPreferencesWizardFinancingOption
                            isSelected={financing === option.value}
                            key={option.value}
                            label={option.label}
                            onSelect={() => setValue("financing", option.value, {shouldDirty: true})}
                            value={option.value}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

const budgetFieldStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const inlineOptionsStyle = css({
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    justifyContent: "space-between"
});

const pillRowStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});

const budgetPriceFieldStyle = css({
    display: "flex",
    flex: "none",
    width: "100%"
});

const budgetControlStyle = css({
    maxWidth: "100%",
    minWidth: 0,

    "& > div": {
        gap: 0,
        justifyContent: "space-between"
    },

    "& > div > div:first-child": {
        flex: "0 0 18.8rem",
        minWidth: 0,
        width: "18.8rem"
    },

    md: {
        "& > div": {
            gap: 3,
            justifyContent: "flex-start"
        },

        "& > div > div:first-child": {
            flex: "1 1 auto",
            width: "auto"
        }
    }
});

const budgetAmountStyle = css({
    flex: "0 0 12rem",
    width: "12rem",

    md: {
        flex: "0 0 24rem",
        width: "24rem"
    }
});

const budgetAmountBoxStyle = css({
    alignItems: "center",
    border: "1px solid var(--colors-secondary)",
    height: "4.8rem",
    justifyContent: "flex-start",
    py: 0,
    width: "12rem",

    md: {
        width: "24rem"
    }
});

const budgetAmountWrapStyle = css({
    flex: "0 0 auto",
    justifyContent: "flex-start",
    width: "auto"
});

const budgetAmountValueStyle = css({
    height: "auto",
    textAlign: "left",

    "&::placeholder": {
        color: "var(--colors-secondary)"
    }
});
import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {PriceField} from "@/components/price_field/PriceField";

import {
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT,
    HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {HomeMatchPreferencesWizardFinancingOption} from "../../home_match_preferences_wizard/HomeMatchPreferencesWizardFinancingOption";

const {BUDGET_QUESTION, FINANCING} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;
const {BUDGET_PLACEHOLDER} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

export const HomeMatchPreferencesSurveyBudgetFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const financing = watch("financing");
    const priceUpper = watch("price.upper");

    return (
        <>
            <div className={budgetFieldStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {BUDGET_QUESTION}
                </Text>
                <div data-testid={KM_PREFERENCES_FORM_TEST_IDS.BUDGET}>
                    <PriceField
                        classNames={{
                            amount: budgetAmountStyle,
                            field: budgetControlStyle,
                            input: budgetAmountValueStyle,
                            inputWrap: budgetAmountWrapStyle,
                            inputWrapper: budgetAmountBoxStyle,
                            root: budgetPriceFieldStyle
                        }}
                        name="price.upper"
                        placeholder={BUDGET_PLACEHOLDER}
                        showPlaceholderAtMin
                        value={priceUpper}
                    />
                </div>
            </div>

            <div className={inlineOptionsStyle}>
                <Text color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {FINANCING}
                </Text>
                <div className={pillRowStyle}>
                    {HOME_MATCH_PREFERENCES_SURVEY_FINANCING_OPTIONS.map((option) => (
                        <HomeMatchPreferencesWizardFinancingOption
                            isSelected={financing === option.value}
                            key={option.value}
                            label={option.label}
                            onSelect={() => setValue("financing", option.value, {shouldDirty: true})}
                            value={option.value}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

const budgetFieldStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const inlineOptionsStyle = css({
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    justifyContent: "space-between"
});

const pillRowStyle = css({
    display: "flex",
    flexWrap: "wrap",
    gap: 1
});

const budgetPriceFieldStyle = css({
    display: "flex",
    flex: "none",
    width: "100%"
});

const budgetControlStyle = css({
    maxWidth: "100%",
    minWidth: 0,

    "& > div": {
        gap: 0,
        justifyContent: "space-between"
    },

    "& > div > div:first-child": {
        flex: "0 0 18.8rem",
        minWidth: 0,
        width: "18.8rem"
    },

    md: {
        "& > div": {
            gap: 3,
            justifyContent: "flex-start"
        },

        "& > div > div:first-child": {
            flex: "1 1 auto",
            width: "auto"
        }
    }
});

const budgetAmountStyle = css({
    flex: "0 0 12rem",
    width: "12rem",

    md: {
        flex: "0 0 24rem",
        width: "24rem"
    }
});

const budgetAmountBoxStyle = css({
    alignItems: "center",
    border: "1px solid var(--colors-secondary)",
    height: "4.8rem",
    justifyContent: "flex-start",
    py: 0,
    width: "12rem",

    md: {
        width: "24rem"
    }
});

const budgetAmountWrapStyle = css({
    flex: "0 0 auto",
    justifyContent: "flex-start",
    width: "auto"
});

const budgetAmountValueStyle = css({
    height: "auto",
    textAlign: "left",

    "&::placeholder": {
        color: "var(--colors-secondary)"
    }
});
